
import React from 'react';
import {Action, TextLoading} from "../../client/funcs/utils";
import email_icon from "./email_icon.png";
import {PershingMailInstructions} from "../../client/funcs/pershing";
import {SchwabMailInstructions} from "../../client/funcs/schwab";

const CheckInstructions = props => {
  const { acct_num, on_click, custodian } = props;

  let instr_div;
  if (custodian === "PERSHING") {
    instr_div = (<PershingMailInstructions account_number={acct_num}/>);
  } else if (custodian === "SCHWAB" || !custodian) {
    instr_div = (<SchwabMailInstructions account_number={acct_num}/>);
  }

  const container_style = {
    textAlign: "left",
  }
  const icon_style = {
    width: "7rem",
    paddingRight: "1rem",
    transform: "translate(0, 2rem)"
  };
  const sending_email = props.sending_email;

  return (
    <div style={container_style}>
      <div>
        <img src={email_icon} alt={"email"} style={icon_style}/>
        <Action onClick={on_click}>
          <TextLoading
            label={"Email me these details"}
            loading={sending_email}/>
        </Action>
      </div>
      <div style={{height: "2rem"}}/>
      { instr_div }
    </div>
  );
}

export { CheckInstructions };
